<template>
  <Notification :show="notification.show" :type="notification.type" :message="notification.message" @click="this.notification.show = false" />
  <div class="page-header h-100">
  <span class="mask bg-gradient-dark opacity-6"></span>
  <div class="container my-auto">
      <div class="row">
        <div class="col-lg-4 col-md-8 col-12 mx-auto">
          <div class="card z-index-0 fadeIn3 fadeInBottom">
            <div class="card-body mt-5">
              <div>
                <h5 class="mb-1">New App</h5>
                <p class="mb-0 font-weight-normal text-sm">Create a new app and generete Token</p>
              </div>
              <form role="form" class="text-start mt-3">
                <div class="mb-3">
                  <material-input
                    id="appName"
                    type="appName"
                    label="App name"
                    name="appName"
                    @retrive-input-value="getValue"
                  />
                </div>
                <div class="text-center">
                  <material-button
                    class="my-4 mb-2"
                    variant="gradient"
                    color="success"
                    fullWidth
                    @click.prevent="summitForm"
                    >Create</material-button
                  >
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialInput from "../components/MaterialInput.vue";
import MaterialButton from "../components/MaterialButton.vue";
import Notification from '../components/Notification.vue'

import { httpPost } from '../services/axios'

export default {
  components: {
    MaterialInput,
    MaterialButton,
    Notification
  },
  data () {
    return {
      form: {},
      notification: {
        show: false,
        type: null,
        message: null
      }
    }
  },
  methods: {
    getValue(inputName, inputValue) {
      this.form[inputName] = inputValue
    },
    configureCheckboxRememberMe() {
      this.form['RememberMe'] = !this.form['RememberMe']
    },
    async summitForm() {
      let res = await httpPost('/create-userApp', this.form)

      if (res.status == 200) {
        this.notification = {
                        type: 'success',
                        show: true,
                        message: "Application token created"
        }
        this.$emit('retrive-event-child-component')


        return
      }
      this.notification = {
                        type: 'danger',
                        show: true,
                        message: res.response.data
        }
    }
  },
  watch: {
    notification: function () {
      if (this.notification.show) {
        setTimeout(() => this.notification.show = false, 3000)
      }
    }
  } 
};
</script>

<style scoped>
.page-header {
  z-index: -1;
}
</style>